var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossIconOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10166",
    "data-name": "Group 10166",
    transform: "translate(-253.382 -159.382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(253.382 159.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Close",
    d: "M16.571,3.375a13.2,13.2,0,1,0,13.2,13.2A13.194,13.194,0,0,0,16.571,3.375Zm3.343,17.973L16.571,18l-3.343,3.343a1.014,1.014,0,1,1-1.434-1.434l3.343-3.343-3.343-3.343a1.014,1.014,0,0,1,1.434-1.434l3.343,3.343,3.343-3.343a1.014,1.014,0,1,1,1.434,1.434L18,16.571l3.343,3.343a1.019,1.019,0,0,1,0,1.434A1.007,1.007,0,0,1,19.914,21.348Z",
    transform: "translate(251.811 157.811)",
    fill: "#f7be00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconOrange);
export default __webpack_public_path__ + "static/media/crossIconOrange.8b2018f982f814bd513ce8aacc1f2637.svg";
export { ForwardRef as ReactComponent };